export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
    };
    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(
      date
    );
    const formattedTime = new Intl.DateTimeFormat("fr-FR", timeOptions)
      .format(date)
      .replace(":", "h");
    return `le ${formattedDate}, à ${formattedTime}`;
  };

